import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import bounceInRightGif from '../../../assets/images/transitions/bounceInRight.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_BOUNCE_OUT_RIGHT = 'bounceOutRight';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const bounceOutRightPresetDetails = {
  // The name of the preset.
  name: PRESET_BOUNCE_OUT_RIGHT,

  // A human friendly name for the preset.
  humanName: 'Bounce Out to the Right',

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // A preview of the transition.
  gif: bounceInRightGif,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'position.x': {
      // The name of the easing this property will use.
      easing: EASINGS.easeInElastic,

      // The start and end times for the transition of this property.
      time: {
        end: 'end.0',
        start: 'end.-1300'
      },

      // The value of the property that will change during the transition.
      values: [
        'position.right',
        'off.right'
      ],

      immediateRender: false,
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_BOUNCE_OUT_RIGHT,
    options: {},
  },
};

bounceOutRightPresetDetails.template.options = lodash.cloneDeep(bounceOutRightPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_BOUNCE_OUT_RIGHT;

// This defines the value of the presets object.
export default bounceOutRightPresetDetails;
